// components
import { Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useMergeCRAccountsPage } from "containers/MergeCRAccounts/useMergeCRAccountsPage";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";

import styles from "containers/MergeCRAccounts/MergeCRAccountsPage.module.css";

// constants
import { MERGE_CR_ACCOUNTS as Constants, PageTitles } from "constants/global";

const MergeCRAccountsPage = () => {
	const { proceedToMergeAccounts, loading, form, uidToCancel, uidToRetain, emailToRetain, handleUidToCancel, handleUidToRetain, handleEmailToRetain } = useMergeCRAccountsPage();

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title={Constants.PAGE_HEADER} subTitle={Constants.PAGE_SUBHEADER} />
			<div className={styles?.root}>
				<Head>{PageTitles.MERGE_CR_ACCOUNTS}</Head>
				<Form className={styles?.form} form={form} requiredMark={false} layout="vertical">
					<Form.Item
						label={<Label requiredMark={true} label={Constants.UID_TO_CANCEL_LABEL} classes={{ label: styles?.basic_input_label }} />}
						name={Constants.UID_TO_CANCEL_LABEL}
					>
						<Input className={styles?.input_field} placeholder={Constants.UID_TO_CANCEL_PLACEHOLDER} value={uidToCancel} onChange={(e) => handleUidToCancel(e)} />
					</Form.Item>
					<Form.Item
						label={<Label requiredMark={uidToRetain !== "" || emailToRetain !== ""} label={Constants.UID_TO_RETAIN_LABEL} classes={{ label: styles?.basic_input_label }} />}
						name={Constants.UID_TO_RETAIN_LABEL}
					>
						<Input className={styles?.input_field} placeholder={Constants.UID_TO_RETAIN_PLACEHOLDER} value={uidToRetain} onChange={(e) => handleUidToRetain(e)} />
					</Form.Item>
					<Form.Item
						label={<Label requiredMark={uidToRetain !== "" || emailToRetain !== ""} label={Constants.EMAIL_TO_RETAIN_LABEL} classes={{ label: styles?.basic_input_label }} />}
						name={Constants.EMAIL_TO_RETAIN_LABEL}
					>
						<Input className={styles?.input_field} placeholder={Constants.EMAIL_TO_RETAIN_PLACEHOLDER} value={emailToRetain} onChange={(e) => handleEmailToRetain(e)} />
					</Form.Item>
					<div className={styles.button_wrapper}>
						<Button
							label={!uidToRetain && !emailToRetain ? Constants.CANCEL_BUTTON_LABEL : Constants.MERGE_BUTTON_LABEL}
							type={(uidToCancel && uidToRetain && emailToRetain) || (uidToCancel && !uidToRetain && !emailToRetain) ? "activeLong" : "disabledLong"}
							onClick={proceedToMergeAccounts}
						/>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default MergeCRAccountsPage;
